module.exports = __webpack_public_path__ + "img/karla.5b615b38.svg";